import React from "react";
import { Helmet } from "react-helmet-async";

const MetaTags = ({ title, description, image, url }) => {
  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* OpenGraph meta tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter Card meta tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      {/* WhatsApp specific meta tags */}
      <meta property="og:site_name" content="G80 or Not" />
      <meta property="og:locale" content="en_US" />
    </Helmet>
  );
};

export default MetaTags;
